module.exports = __webpack_public_path__ + "img/spot.68d05199.png";